import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  CREATE_PATIENT_ACCOUNT,
  CREATE_PATIENT_ACCOUNT_ERROR,
  CREATE_PATIENT_ACCOUNT_SUCCESS,
} from '../type';
import { initialState } from './initialize';

const createAccountReducer = handleActions(
  new Map([
    [
      CREATE_PATIENT_ACCOUNT,
      state => {
        return update(state, {
          createAccountData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      CREATE_PATIENT_ACCOUNT_ERROR,
      (state, action) => {
        return update(state, {
          createAccountData: {
            error: {
              $set: action.payload,
            },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      CREATE_PATIENT_ACCOUNT_SUCCESS,
      (state, action) => {
        return update(state, {
          createAccountData: {
            data: { $set: action.payload },
            loading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);

export default createAccountReducer;
